import React from 'react';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { SearchBox } from '@bingads-webui-react/search-box-control';

import { getStyles } from './getStyles';

export class DummyCustomerSelectorUnthemed extends React.PureComponent {
  render() {
    return (
      <SearchBox
        onQueryChange={() => { }}
        onSearch={() => { }}
        value=""
      />
    );
  }
}

export const DummyCustomerSelector = withDefaultStyles(DummyCustomerSelectorUnthemed, getStyles);
